import date from './modules/date';
import korotko from './modules/korotko';
import maincontent from './modules/maincontent';
import rebus from './modules/rebus';
import timer from './modules/timer';
import test from './modules/test';

window.addEventListener('DOMContentLoaded', () => {

    date();
    maincontent();
    rebus();
    test();
    try {korotko();} catch(e) {}
});